<template>
  <div>
    <div class="form-group text-muted">
      <label>ID:</label>
      {{project.id}}
    </div>
    <text-input :value="project.name" @input label="Titel" ref="name"></text-input>
    <text-input
      :value="project.shortTitle"
      @input
      label="Kurztitel (Original vom SNF)"
      ref="shortTitle"
    ></text-input>
    <long-text-input v-model="project.description" label="Lead" ref="description"></long-text-input>
    <div class="admin-info">Bitte keine Titel, Listen, etc. verwenden.</div>
    <hr>
    <long-text-input
      v-model="project.longDescription"
      label="Auf einen Blick"
      ref="longDescription"
    ></long-text-input>
    <div
      class="admin-info"
    >Für die Zwischentitel bitte den dritten Überschriftsgrad (### Überschrift) verwenden.</div>
    <hr>
    <entity-multiselect
      entity="tag"
      label="Tags"
      :value="project.tagIds"
      @input="changedTags"
      name="tags"
    ></entity-multiselect>
    <entity-multiselect
      entity="key_theme"
      label="Themenschwerpunkte"
      :value="project.keyThemeIds"
      @input="changedKeyThemes"
      name="key_themes"
    ></entity-multiselect>
    <entity-multiselect
      entity="project"
      label="Ähnliche Projekte"
      :value="project.relatedProjectIds"
      @input="changedRelatedProjects"
      name="related_projects"
    ></entity-multiselect>
    <entity-multiselect
      entity="umbrella_project"
      label="Ähnliche Verbundprojekte"
      :value="project.relatedUmbrellaProjectIds"
      @input="changedRelatedUmbrellaProjects"
      name="key_themes"
    ></entity-multiselect>
    <entity-multiselect
      v-if="project.class === 'UmbrellaProject'"
      entity="project"
      label="Verbundene Projekte"
      :value="project.projectIds"
      @input="changedProjects"
      name="projects"
    ></entity-multiselect>
    <div class="form-group">
      <label>Version</label>
      <multiselect
        v-model="version"
        placeholder="Version"
        :options="options"
        track-by="id"
        :allow-empty="false"
        label="name"
      >
        <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
      </multiselect>
    </div>
    <div class="form-group">
      <label>Programm</label>
      <multiselect
        v-model="program"
        placeholder="Programm"
        :options="programOptions"
        track-by="id"
        :allow-empty="false"
        label="name"
      >
        <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
      </multiselect>
    </div>
    <div class="form-group">
      <label>Projektnummer</label>
      <input v-model="project.number" class="form-control">
    </div>
    <div class="form-group">
      <label>Projektleiter</label>
      <input v-model="project.lead" class="form-control">
    </div>
    <file-input v-model="project.images" label="Bilder" type="image" :max-files="12"/>
    <div class="admin-info">
      <p>
        Das erste Bild wird als Titelbild verwendet, die anderen Bilder können in den Texten eingebunden werden
        mit dem Code
      </p>
      <pre>[img id=ID align=[left|right|center] size=[1|2|3]]</pre>
    </div>
    <hr>

    <h3>Team</h3>
    <researchers v-model="project.researchers"/>
    <long-text-input v-model="project.contact" label="Kontaktangaben" ref="contact"></long-text-input>
    <div class="admin-info">
      <ul>
        <li>Bitte Name des Projektleiters mit ### angeben</li>
        <li>
          Bitte volle Adresse angeben, jede Zeile mit zwei Leerzeichen beenden, damit die Zeilenumbrüche
          übernommen werden
        </li>
        <li>
          Bitte nach Adresse Telefonnummer und E-Mail (als Link mit mailto:test@test.ch) angeben, diesen Block
          mit einer leeren Zeile von der Adresse trennen
        </li>
      </ul>
    </div>
    <hr>
    <entity-multiselect
      entity="partner"
      label="Partner"
      :value="this.partnerIds"
      @input="changedPartners"
      name="partners"
    ></entity-multiselect>
    <div class="admin-info">Die Partner bitte separat anlegen und dann hier verknüpfen.</div>

    <hr>

    <div class="position-relative">
      <div class="form-group">
        <label for="input_available_from">Disclaimer Datum</label>
        <date-picker
          v-model="disclaimerDate"
          :config="datePickerOptions"
          id="input_disclaimer_date"
        ></date-picker>
      </div>
    </div>

    <hr>

    <button class="btn btn-primary" @click="save">Save</button>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";

export default {
  props: ["data"],
  components: { Multiselect },
  data() {
    let versions = {
      1: "Bearbeiten",
      2: "Review",
      3: "Übersetzung",
      9: "Online"
    };
    return {
      partnerIds: this.data.partners.map(pa => {
        return pa.id;
      }),
      project: this.data,
      tagIds: this.data.tagIds,
      keyThemeIds: this.data.keyThemeIds,
      relatedUmbrellaProjectIds: this.data.relatedUmbrellaProjectIds,
      projectIds:
        this.data.class === "UmbrellaProject" ? this.data.projectIds : [],
      relatedProjectIds: this.data.relatedProjectIds,
      version: { id: this.data.version, name: versions[this.data.version] },
      program: { id: this.data.program, name: this.data.program },
      options: [
        { name: versions[1], id: 1 },
        { name: versions[2], id: 2 },
        { name: versions[3], id: 3 },
        { name: versions[9], id: 9 }
      ],
      programOptions: [{ name: 70, id: 70 }, { name: 71, id: 71 }],
      disclaimerDate: this.data.disclaimerDate && this.data.disclaimerDate.format('DD.MM.YYYY'),
      datePickerOptions: {
        useCurrent: false,
        format: 'DD.MM.YYYY'
      }
    };
  },
  methods: {
    changedTags(value) {
      this.tagIds = value;
    },
    changedKeyThemes(value) {
      this.keyThemeIds = value;
    },
    changedRelatedProjects(value) {
      this.relatedProjectIds = value;
    },
    changedRelatedUmbrellaProjects(value) {
      this.relatedUmbrellaProjectIds = value;
    },
    changedProjects(value) {
      this.projectIds = value;
    },
    changedPartners(value) {
      this.partnerIds = value;
    },
    save() {
      this.$refs.name.save();
      this.$refs.shortTitle.save();
      this.$refs.description.save();
      this.$refs.longDescription.save();
      this.$refs.contact.save();

      let form = new FormData();
      let form_prefix =
        this.project.class == "UmbrellaProject"
          ? "edit_umbrella_project"
          : "edit_project";
      for (let id of this.partnerIds) {
        form.append(form_prefix + "[partners][]", id);
      }
      for (let id of this.keyThemeIds) {
        form.append(form_prefix + "[keyThemes][]", id);
      }
      for (let id of this.tagIds) {
        form.append(form_prefix + "[tags][]", id);
      }
      for (let id of this.relatedProjectIds) {
        form.append(form_prefix + "[relatedProjects][]", id);
      }
      for (let id of this.relatedUmbrellaProjectIds) {
        form.append(form_prefix + "[relatedUmbrellaProjects][]", id);
      }
      for (let i = 0; i < this.project.images.length; i++) {
        form.append(
          form_prefix + "[images][" + i + "]",
          this.project.images[i].id
        );
      }
      for (let i = 0; i < this.project.researchers.length; i++) {
        form.append(
          form_prefix + "[researchers][" + i + "]",
          this.project.researchers[i].id
        );
      }

      if (this.project.class === "UmbrellaProject") {
        for (let id of this.projectIds) {
          form.append(form_prefix + "[projects][]", id);
        }
      }

      form.append(form_prefix + "[projectVersion]", this.version.id);
      form.append(form_prefix + "[program]", this.program.id);

      if (this.project.number) {
        form.append(form_prefix + "[number]", this.project.number);
      } else {
        form.append(form_prefix + "[number]", "");
      }
      if (this.project.lead) {
        form.append(form_prefix + "[lead]", this.project.lead);
      } else {
        form.append(form_prefix + "[lead]", "");
      }

      form.append(form_prefix + "[disclaimerDate]", this.disclaimerDate);

      store.commit("addSavingProcess");
      axios
        .post(
          "/api/" +
            store.state.language +
            "/" +
            (this.project.class == "UmbrellaProject" ? "umbrella_" : "") +
            "project/" +
            this.project.id +
            "/edit",
          form
        )
        .then(() => {
          store.commit("finishSavingProcess");
          this.$emit("saved", this.value);
        });
    }
  },
  computed: {}
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/project/General.vue